(function () {
  'use strict';
  if (window.sgBfOrbit) { window.sgBfOrbit.scan(document); return; }
  var instances = new Map();
  var slots = [
    { x: 0, sx: 1, sy: 1, tilt: 0, opacity: 1 },
    { x: 291, sx: 247 / 303, sy: 1, tilt: 1.15, opacity: 1 },
    { x: 534, sx: 207 / 303, sy: 464 / 496, tilt: 1.8, opacity: 1 },
    { x: 725, sx: 143 / 303, sy: 432 / 496, tilt: 2.65, opacity: 1 },
    { x: 875, sx: .36, sy: .82, tilt: 3.2, opacity: 0 }
  ];
  function mod(value, total) { return (value % total + total) % total; }
  function distance(value, total) { return mod(value + total / 2, total) - total / 2; }
  function blend(a, b, amount) { return a + (b - a) * amount; }
  function geometry(d) {
    var absolute = Math.min(Math.abs(d), 3.999), index = Math.min(3, Math.floor(absolute)), fraction = absolute - index;
    var first = slots[index], second = slots[index + 1], result = {};
    ['x', 'sx', 'sy', 'tilt', 'opacity'].forEach(function (key) { result[key] = blend(first[key], second[key], fraction); });
    result.x *= Math.sign(d) || 1; return result;
  }
  function trapezoid(d, shape, height) {
    var width = 303 * shape.sx, h = height * shape.sy, cut = h * shape.tilt / 100;
    var points = d < 0 ? [{ x: 0, y: cut }, { x: width, y: 0 }, { x: width, y: h }, { x: 0, y: h - cut }] : [{ x: 0, y: 0 }, { x: width, y: cut }, { x: width, y: h - cut }, { x: 0, y: h }];
    var rounded = points.map(function (point, index) {
      var before = points[mod(index - 1, 4)], after = points[mod(index + 1, 4)];
      var incoming = Math.hypot(before.x - point.x, before.y - point.y), outgoing = Math.hypot(after.x - point.x, after.y - point.y), radius = Math.min(14, incoming / 2, outgoing / 2);
      return { corner: point, enter: { x: point.x + (before.x - point.x) / incoming * radius, y: point.y + (before.y - point.y) / incoming * radius }, exit: { x: point.x + (after.x - point.x) / outgoing * radius, y: point.y + (after.y - point.y) / outgoing * radius } };
    });
    function coord(point) { return (point.x / shape.sx).toFixed(3) + ' ' + (point.y / shape.sy).toFixed(3); }
    var path = 'M ' + coord(rounded[0].exit);
    for (var i = 1; i <= 4; i += 1) { var corner = rounded[i % 4]; path += ' L ' + coord(corner.enter) + ' Q ' + coord(corner.corner) + ' ' + coord(corner.exit); }
    return 'path("' + path + ' Z")';
  }
  function init(root) {
    if (instances.has(root)) return;
    var stage = root.querySelector('[data-sg-orbit-stage]'), track = root.querySelector('[data-sg-orbit-track]');
    track.querySelectorAll('[data-sg-orbit-clone]').forEach(function (node) { node.remove(); });
    var originals = Array.from(track.querySelectorAll('[data-sg-orbit-card]')), realCount = originals.length;
    var cards = originals.slice(), physicalCount = realCount;
    var controls = root.querySelector('[data-sg-orbit-controls]'), status = root.querySelector('[data-sg-orbit-status]');
    controls.hidden = realCount < 2; stage.hidden = !realCount;
    root.classList.toggle('is-interactive', realCount > 1);
    root.dataset.realCount = realCount;
    if (realCount > 1 && realCount < 7) {
      physicalCount = Math.ceil(9 / realCount) * realCount;
      for (var copyIndex = realCount; copyIndex < physicalCount; copyIndex += 1) {
        var clone = originals[copyIndex % realCount].cloneNode(true);
        clone.dataset.sgOrbitClone = 'true';
        [clone].concat(Array.from(clone.querySelectorAll('*'))).forEach(function (node) {
          Array.from(node.attributes).forEach(function (attribute) { if (attribute.name === 'id' || attribute.name === 'data-block-id' || attribute.name.indexOf('data-shopify') === 0 || attribute.name === 'tabindex' || attribute.name === 'contenteditable') node.removeAttribute(attribute.name); });
          if (node.tagName === 'A') node.removeAttribute('href');
          if (/^(BUTTON|INPUT|TEXTAREA|SELECT)$/.test(node.tagName)) { node.disabled = true; node.tabIndex = -1; }
        });
        clone.setAttribute('aria-hidden', 'true'); track.appendChild(clone); cards.push(clone);
      }
    }
    var phase = Math.floor(realCount / 2), target = phase, frame = 0, destroyed = false, drag = null, suppressUntil = 0;
    root.dataset.phase = phase.toFixed(5); root.dataset.targetPhase = target.toFixed(5);
    var mobile = false, scale = 1, width = 303, imageHeight = 496, cardHeight = 550, step = 291;
    var reduced = matchMedia('(prefers-reduced-motion: reduce)');
    function state(value) { root.dataset.state = value; }
    function draw() {
      if (!realCount) return;
      var centered = mod(Math.round(phase), physicalCount);
      cards.forEach(function (card, index) {
        var d = distance(index - phase, physicalCount), absolute = Math.abs(d), visible = absolute < 3.45;
        var shape = mobile ? { x: d * step, sx: 1 - .06 * Math.min(1, absolute), sy: 1 - .06 * Math.min(1, absolute), opacity: 1 } : geometry(d);
        var opacity = shape.opacity * Math.max(0, Math.min(1, (3.45 - absolute) / .25));
        card.style.transform = 'translate3d(calc(-50% + ' + shape.x.toFixed(3) + 'px),-50%,0) scale3d(' + shape.sx.toFixed(5) + ',' + shape.sy.toFixed(5) + ',1)';
        card.style.clipPath = mobile ? 'none' : trapezoid(d, shape, cardHeight);
        card.style.zIndex = String(Math.max(1, 80 - Math.round(20 * absolute)));
        card.style.opacity = visible ? String(opacity) : '0';
        card.style.visibility = visible ? 'visible' : 'hidden';
        card.style.pointerEvents = visible ? 'auto' : 'none';
        card.setAttribute('aria-hidden', index === centered ? 'false' : 'true');
      });
      root.dataset.phase = phase.toFixed(5); root.dataset.targetPhase = target.toFixed(5);
    }
    function announce() {
      var index = realCount ? mod(Math.round(phase), realCount) : 0;
      root.dataset.activeIndex = String(index);
      var text = realCount ? 'Project ' + (index + 1) + ' of ' + realCount : '';
      if (status.textContent !== text) status.textContent = text;
    }
    function stop() { cancelAnimationFrame(frame); frame = 0; }
    function settle() {
      phase = realCount ? mod(Math.round(target), physicalCount) : 0; target = phase;
      state('idle'); draw(); announce();
    }
    function animate(goal) {
      stop(); target = goal;
      if (reduced.matches || Math.abs(target - phase) < .0001) { settle(); return; }
      var from = phase, delta = target - phase, started = performance.now(), duration = 380 + Math.min(100, 80 * Math.abs(delta));
      state('animating');
      function tick(now) {
        if (destroyed) return;
        var t = Math.min(1, (now - started) / duration);
        phase = from + delta * (1 - Math.pow(1 - t, 5)); draw();
        if (t < 1) frame = requestAnimationFrame(tick);
        else { frame = 0; settle(); }
      }
      frame = requestAnimationFrame(tick);
    }
    function releaseCapture(pointer) { try { if (stage.hasPointerCapture && stage.hasPointerCapture(pointer)) stage.releasePointerCapture(pointer); } catch (_) { /* Browser can release on pointercancel first. */ } }
    function cancelDrag() {
      if (!drag) return;
      var old = drag; drag = null; releaseCapture(old.id);
      if (old.intent === 'horizontal') animate(Math.round(phase));
    }
    function moveBy(dir) {
      if (realCount < 2) return;
      if (drag) cancelDrag();
      animate(Math.round(target) + dir);
    }
    function moveTo(index) {
      if (!realCount) return;
      if (drag) cancelDrag();
      var rounded = Math.round(target), difference = distance(index - mod(rounded, realCount), realCount);
      animate(rounded + difference);
    }
    function measure() {
      if (destroyed || !realCount) return;
      mobile = window.innerWidth < 900;
      width = mobile ? Math.min(320, window.innerWidth * .64) : 303;
      imageHeight = mobile ? width * 496 / 303 : 496;
      scale = mobile ? 1 : stage.clientWidth / 1593;
      step = mobile ? width + 16 : 291 * scale;
      root.classList.toggle('is-mobile', mobile);
      root.style.setProperty('--sg-orbit-width', width + 'px');
      root.style.setProperty('--sg-orbit-photo-height', imageHeight + 'px');
      var caption = originals.reduce(function (height, card) { var element = card.querySelector('.sg-orbit__caption'); return Math.max(height, element ? element.scrollHeight : 0); }, 0);
      cardHeight = imageHeight + caption;
      root.style.setProperty('--sg-orbit-card-height', cardHeight + 'px');
      stage.style.height = cardHeight * scale + 'px';
      track.style.width = (mobile ? stage.clientWidth : 1593) + 'px'; track.style.height = cardHeight + 'px';
      track.style.transform = 'translate(-50%,-50%) scale(' + scale + ')';
      draw(); root.classList.add('is-ready');
    }
    function pointerDown(event) {
      if (realCount < 2 || (event.button !== undefined && event.button !== 0) || event.target.closest('a,button,input,textarea,select')) return;
      if (drag && drag.id !== event.pointerId) return;
      if (drag) cancelDrag();
      drag = { id: event.pointerId, startX: event.clientX, startY: event.clientY, origin: phase, intent: '', lastX: event.clientX, lastTime: performance.now(), velocity: 0 };
    }
    function pointerMove(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var dx = event.clientX - drag.startX, dy = event.clientY - drag.startY;
      if (!drag.intent) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx) * 1.15) { drag = null; return; }
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.1) return;
        stop(); drag.intent = 'horizontal'; drag.origin = phase;
        target = phase; state('dragging');
        try { stage.setPointerCapture(event.pointerId); } catch (_) { /* Synthetic fixture events cannot capture a real pointer. */ }
      }
      if (event.cancelable) event.preventDefault();
      var now = performance.now(), elapsed = Math.max(16, now - drag.lastTime);
      drag.velocity = (event.clientX - drag.lastX) / elapsed;
      drag.lastX = event.clientX; drag.lastTime = now;
      phase = drag.origin - dx / step; target = phase; draw();
    }
    function pointerEnd(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var old = drag; drag = null; releaseCapture(old.id);
      if (old.intent !== 'horizontal') return;
      suppressUntil = performance.now() + 300;
      var boost = event.type === 'pointerup' && performance.now() - old.lastTime < 100 ? Math.max(-.35, Math.min(.35, old.velocity / step * 140)) : 0;
      animate(Math.round(phase - boost));
    }
    function click(event) {
      if (performance.now() < suppressUntil && stage.contains(event.target)) { event.preventDefault(); event.stopPropagation(); return; }
      if (event.target.closest('[data-sg-orbit-prev]')) moveBy(-1);
      else if (event.target.closest('[data-sg-orbit-next]')) moveBy(1);
    }
    function keydown(event) {
      if (!stage.contains(event.target) || realCount < 2) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); moveBy(-1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); moveBy(1); }
      else if (event.key === 'Home') { event.preventDefault(); moveTo(0); }
      else if (event.key === 'End') { event.preventDefault(); moveTo(realCount - 1); }
    }
    function lost(event) { if (drag && drag.id === event.pointerId) cancelDrag(); }
    function blockSelected(event) { var id = event.detail && event.detail.blockId; var index = originals.findIndex(function (card) { return card.dataset.blockId === id; }); if (index >= 0) moveTo(index); }
    function motionChanged() { if (reduced.matches && frame) { stop(); settle(); } }
    function preventImageDrag(event) { event.preventDefault(); }
    root.addEventListener('click', click); root.addEventListener('keydown', keydown);
    stage.addEventListener('pointerdown', pointerDown); stage.addEventListener('pointermove', pointerMove, { passive: false }); stage.addEventListener('lostpointercapture', lost); stage.addEventListener('dragstart', preventImageDrag);
    window.addEventListener('pointerup', pointerEnd); window.addEventListener('pointercancel', pointerEnd); window.addEventListener('blur', cancelDrag); window.addEventListener('resize', measure, { passive: true });
    document.addEventListener('shopify:block:select', blockSelected); reduced.addEventListener('change', motionChanged);
    var resize = 'ResizeObserver' in window ? new ResizeObserver(measure) : null; if (resize) resize.observe(stage);
    instances.set(root, function () {
      destroyed = true; stop(); if (drag) { var pointer = drag.id; drag = null; releaseCapture(pointer); }
      if (resize) resize.disconnect();
      root.removeEventListener('click', click); root.removeEventListener('keydown', keydown); stage.removeEventListener('pointerdown', pointerDown); stage.removeEventListener('pointermove', pointerMove); stage.removeEventListener('lostpointercapture', lost); stage.removeEventListener('dragstart', preventImageDrag);
      window.removeEventListener('pointerup', pointerEnd); window.removeEventListener('pointercancel', pointerEnd); window.removeEventListener('blur', cancelDrag); window.removeEventListener('resize', measure); document.removeEventListener('shopify:block:select', blockSelected); reduced.removeEventListener('change', motionChanged);
      track.querySelectorAll('[data-sg-orbit-clone]').forEach(function (node) { node.remove(); });
    });
    measure(); announce();
    if (!realCount) root.classList.add('is-ready');
    if (document.fonts) document.fonts.ready.then(function () { if (!destroyed) measure(); });
  }
  function scan(scope) { if (scope.matches && scope.matches('[data-sg-orbit]')) init(scope); scope.querySelectorAll('[data-sg-orbit]').forEach(init); }
  window.sgBfOrbit = { scan: scan, destroy: function (root) { if (instances.has(root)) { instances.get(root)(); instances.delete(root); } }, instanceCount: function () { return instances.size; } };
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); instances.delete(root); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
})();
